import { Content } from "@/ui/Content";
import * as additionalComponents from "@/components/AboutPage";
import { router } from "@/router";
import { stripTags } from "@/functions/stripTags";
import { getGlobal } from "@/functions/getGlobal";
import sourceflowEnums from "@/sourceflow.enums";

export default function Page({ content }) {
  return (
    <>
      <Content items={content} additionalComponents={additionalComponents} />
    </>
  );
}

export async function getStaticProps({}) {
  const global = getGlobal();
  const routerProp = router["about"];
  const titleKey = "page.about.banner.title";

  return {
    props: {
      meta: {
        en: {
          title: stripTags(global[`${titleKey}.en`]),
          canonical: `${sourceflowEnums.config.baseUrl}${routerProp["en"]}`,
        },
      },
      router: routerProp,
      content: [
        { component: "AboutPageBannerSection", props: { className: "" } },
        { component: "AboutPageContentSection", props: { className: "py-4 py-md-5" } },
        { component: "AboutPageTeamSection", props: { className: "py-4 py-md-5" } },
        { component: "ValuesSection", props: { className: "py-4 py-md-5", tags: "About" } },
        { component: "HistorySection", props: { className: "py-4 py-md-5" } },
        { component: "SolutionsSection", props: { className: "py-4 py-md-5" } },
        { component: "AboutPageDiversitySection", props: { className: "py-4 py-md-5" } },
        { component: "StatisticsSection", props: { className: "py-4 py-md-5" } },
        { component: "AwardsSection", props: { className: "py-4 py-md-5" } },
      ],
    },
  };
}
